import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import TeamBudgetInputContainer from '../../containers/team-budget-input/TeamBudgetInputContainer';

const TeamBudgetInputPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="결산관리/팀별 예산 관리" icon="budget" />
      <TeamBudgetInputContainer />
    </>
  );
};

export default TeamBudgetInputPage;
